__turbopack_context__.v({
  "accessoriesCarousel": "AccessoriesCarousel-module-scss-module___n2AAW__accessoriesCarousel",
  "app_light_theme": "AccessoriesCarousel-module-scss-module___n2AAW__app_light_theme",
  "card": "AccessoriesCarousel-module-scss-module___n2AAW__card",
  "inner": "AccessoriesCarousel-module-scss-module___n2AAW__inner",
  "isDragging": "AccessoriesCarousel-module-scss-module___n2AAW__isDragging",
  "tabButtonType": "AccessoriesCarousel-module-scss-module___n2AAW__tabButtonType",
  "tabs": "AccessoriesCarousel-module-scss-module___n2AAW__tabs",
});
